import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-users",
  "use": "menu-users-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"menu-users\"><defs><style>#menu-users .cls-1{fill:none}</style></defs><title>内部组织架构</title><g id=\"menu-users_图层_2\" data-name=\"图层 2\"><g id=\"menu-users_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M0 0h16v16H0z\" /><path d=\"M13.92 10.56H13V8a.58.58 0 0 0-.57-.59h-4v-2h.95a.58.58 0 0 0 .58-.59V2.1a.58.58 0 0 0-.58-.59H6.66a.56.56 0 0 0-.57.59v2.75a.57.57 0 0 0 .57.59h1v2h-4A.58.58 0 0 0 3 8v2.56h-.92a.59.59 0 0 0-.58.59v2.75a.58.58 0 0 0 .58.59h2.67a.57.57 0 0 0 .41-.17.54.54 0 0 0 .16-.42v-2.75a.57.57 0 0 0-.57-.59h-1V8.2h3.87v2.36h-1a.57.57 0 0 0-.57.59v2.75a.57.57 0 0 0 .57.59h2.71a.55.55 0 0 0 .41-.17.59.59 0 0 0 .17-.42v-2.75a.58.58 0 0 0-.58-.59h-.95V8.2h3.82v2.36h-.95a.59.59 0 0 0-.58.59v2.75a.58.58 0 0 0 .58.59h2.67a.57.57 0 0 0 .41-.17.59.59 0 0 0 .17-.42v-2.75a.59.59 0 0 0-.58-.59\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-users.svg
// module id = JSBU
// module chunks = 6